import {Injectable} from '@angular/core';
import {GenericResourceInMemoryHandler} from '@catfeatures/shared/generic-resource-in-memory-handler';
import {ResourceHandler} from '@catfeatures/types';
import {Restangular} from 'ngx-restangular';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {isNullOrUndefined} from 'util';

@Injectable()
export class GenericResourceService {

  private routeBasedParentResource = new BehaviorSubject(null);
  private routeBasedParentResource$ = this.routeBasedParentResource.asObservable();

  constructor(private http: Restangular) {
  }

  findServiceForResource(resourceId: string): ResourceHandler {
    let service = availableResources.get(resourceId);

    if (isNullOrUndefined(service)) {
      availableResources.set(
        resourceId,
        new GenericResourceInMemoryHandler(resourceId, this.http),
      );
      service = availableResources.get(resourceId);
    }
    return service;
  }

}

const availableResources = new Map<string, ResourceHandler>();



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/services/generic-resource.service.ts